<div class="bc-workitem-genesys-chat-list">
  <div class="bc-sidenav-title-wrapper">
    <h2 class="bc-sidenav-title" data-automation-id="genesys-chat-list-title">
      <svg-icon icon="chat-large"></svg-icon>
      <span class="bc-sidenav-title-label">{{ ( isHybrid ? 'bcWorkItemGenesysChatList.cxTitleChats' : 'bcWorkItemGenesysChatList.titleChats' ) | translate}}</span>
      <span> ({{ conversationCount$ | async }})</span>
    </h2>
  </div>

  <ul class="bc-workitem-titles-list">
    <li class="outer-item" *ngFor="let conversation of conversations$ | async; trackBy: conversationTrackByFn"
        [@taskItemAnimation]
        [attr.data-workitem-id]="conversation.id">
      <app-work-item-genesys-chat-list-item [conversation]="conversation"
                                            [isOpened]="isOpened(conversation.id)"
                                            [isFocused]="isFocused(conversation.id)" >
      </app-work-item-genesys-chat-list-item>
    </li>
  </ul>
</div>
